module.exports = __webpack_public_path__ + "img/hubgrade-oscuro.f8eb9959.svg";